import { render, staticRenderFns } from "./CouponListPopup.vue?vue&type=template&id=c2df063c&scoped=true&"
import script from "./CouponListPopup.vue?vue&type=script&lang=js&"
export * from "./CouponListPopup.vue?vue&type=script&lang=js&"
import style0 from "./CouponListPopup.vue?vue&type=style&index=0&id=c2df063c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2df063c",
  null
  
)

export default component.exports